export const endpoints = {
  codetableAccess: 'optionsCollection/access',
  hierarchy: 'optionsCollection/hierarchy'
};
